import Vue from 'vue';
import PluginsTemplate from '@/plugins/pluginsTemplate';
import baseListSelector from './index.vue';

const TreeSelectorConstructor = Vue.extend(baseListSelector);

class TreeSelectorPlugin extends PluginsTemplate {
  constructor() {
    super();
  }
  show(props) {
    this.initPros(props);
    // 如果不存在实例 则初始化实例
    if (!this.instance) {
      let newInstance = new TreeSelectorConstructor({
        el: document.createElement('div'),
      });
      this.initInstance(newInstance);
    }
    // 初始化节点
    this.initDom();
  }

  initMethods() {
    this.instance.$off('onCancel');
    this.instance.$on('onCancel', (result) => {
      this.close();
      this.props.onCancel && this.props.onCancel(result);
    });
    this.instance.$off('onOk');
    this.instance.$on('onOk', (result) => {
      this.close();
      this.props.onOk && this.props.onOk(result);
    });
    this.instance.$off('update-list');
    this.instance.$on('update-list', (result) => {
      this.props.updateList && this.props.updateList(result);
    });
  }

  close() {
    if (!this.instance) {
      return !1;
    }
    this.removeInstance();
  }
}

let instance;
export default {
  open(props) {
    instance = new TreeSelectorPlugin();
    instance.show(props);
    return instance;
  },
  install() {},
};
